// extracted by mini-css-extract-plugin
export default {"conversation":"rrWPBq5HopTsDYXBbVD6","avatar":"vTSNHBoFyDmZ0QmCp4Go","content":"pktDozj4PT_9izdXwFJI","message":"QvuN2XtT_mANNeAMiAWX","meta":"cgdXSGFar4PIrXWp1EGN"};